export const useEnvStore = defineStore('env', () => {
  return {
    isDevMode: import.meta.env.DEV,
    isProdMode: import.meta.env.PROD,
    isLoggedInUser: document.body.classList.contains('logged-in'),
  }
})
